import { actionTypes } from "./officeActionTypes";
import * as State from "./officeInitialState";

const INITIAL_STATE = {
  isLoading: false,
  officesLoading: false,
  offices: [],
  officesCompanyId: null, // company id that the current offices list belongs to
  countries: [],
  states: [],
  businessDaysPresets: [],
  officeBusinessDays: {}, // Store business days for each office by officeId
  name: '',
  countryId: '',
  stateId: '',
  address: '',
  businessDaysValue: 62, // Default value as specified
  officeForEdit: null
};

export default function officeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOADING:
      return {
        ...state,
        isLoading: action.value
      };
    case actionTypes.OFFICES_LOADING:
      return {
        ...state,
        officesLoading: action.value
      };
    case actionTypes.SET_OFFICES:
      return {
        ...state,
        offices: action.offices,
        officesCompanyId: action.companyId !== undefined ? action.companyId : state.officesCompanyId,
        officesLoading: false
      };
    case actionTypes.GET_COUNTRIES:
      return {
        ...state,
        countries: action.payload
      };
    case actionTypes.GET_STATES:
      return {
        ...state,
        states: action.payload
      };
    case actionTypes.GET_BUSINESS_DAYS_PRESETS:
      return {
        ...state,
        businessDaysPresets: action.payload
      };
    case actionTypes.GET_OFFICE_BUSINESS_DAYS:
      return {
        ...state,
        officeBusinessDays: {
          ...state.officeBusinessDays,
          [action.payload.officeId]: action.payload.businessDays
        }
      };
    case actionTypes.SET_OFFICE_FOR_EDIT:
      return {
        ...state,
        officeForEdit: action.payload
      };
    case actionTypes.CLEAR_OFFICE_FOR_EDIT:
      return {
        ...state,
        officeForEdit: null
      };
    case actionTypes.INCREMENT_OFFICE_USER_COUNT:
      if (!action.officeId) return state;
      return {
        ...state,
        offices: (state.offices || []).map((office) => {
          const officeId = office.id ?? office.Id;
          if (Number(officeId) === Number(action.officeId)) {
            const current = office.userCount !== undefined && office.userCount !== null ? office.userCount : 0;
            return { ...office, userCount: current + 1 };
          }
          return office;
        }),
      };
    // case actionTypes.SET_OFFICE_SELECTED:
    //   return { ...state, isOfficeSelected: true };
    // case actionTypes.REMOVE_OFFICE_SELECTED:
    //   return { ...state, isOfficeSelected: false };
    // case actionTypes.CLEAR_OFFICE_ERRORS:
    //   return {
    //     ...state,
    //     officeErrors: { ...state.officeErrors }
    //   };
    default:
      return {
        ...state
      };
  }
}
